export class AlarmSettingConfiguration {
  defaultHotTemp?: number;
  defaultColdTemp?: number;
  defaultHotTempMax?: number;
  defaultHotTempMin?: number;
  defaultColdTempMax?: number;
  defaultColdTempMin?: number;
  defaultTempMaxFallback?: number;
  defaultTempMinFallback?: number;
  defaultEffectMaxFallback?: number;
  defaultEffectMinFallback?: number;
  defaultEffectHourlyFallback?: number;
  defaultEffectDailyFallback?: number;
  defaultNotifyByEmail: boolean;
  defaultNotifyBySystem: boolean;
  defaultNotifyByTextMessage: boolean;
}
